import styled from 'styled-components';

const Container = styled.div`
  position: relative;

  display: flex;

  padding-bottom: 3rem;

  input {
    width: 8rem;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { Container, LoadingContainer };
